// IMAGES //
import the_80s from "../../assets/the_80s.jpg";
import PVGLogo from "../PVGLogo";

// STYLES // 
import "./comics.css"

import CreationMeter from "../CreationMeter";

export default function Comics() {
    return (
        <div id="comics">
            <div className="comic-card">
                <a href="https://www.webtoons.com/p/community/en/u/aplanetaryshift" target="_blank" rel="noreferrer">
                    <PVGLogo
                        className="comics-logo"
                        size={200}
                        tint={0x000000}
                    />
                </a>

                <p className="read-link">Tap Logo to Read</p>

                <p className="comics-description">
                    <b>
                        <a href="https://www.webtoons.com/p/community/en/u/aplanetaryshift" target="_blank" rel="noreferrer">
                            PIXIES VS GIANTS
                        </a>
                    </b>

                    {" "}|
                    In a remote forest, about one hundred years from now, bankrupt Victoria and her band of intrepid women attempt to destroy the child she holds responsible for her deplorable station in life. Someone intervenes.

                    <br />
                    <br />

                    <b>Genre:</b> Dark Fantasy | Science Fiction <br />
                    <b>Format:</b> Graphic Novel <br />
                    <b>Rating:</b> Mature (18+) for violence, strong language, and mature themes. <br />
                    <b>Re-Release:</b> Winter 2027 <br />
                    <b>Status:</b> Production <br />
                </p>

                <CreationMeter
                    humanPercent={100}
                    humanLabel="Hand-Drawn Images"
                    aiLabel="AI-Generated Images"
                />

            </div>

        </div>
    )
}